import { render } from "./SingerView.vue?vue&type=template&id=7bbb287d&ts=true"
import script from "./SingerView.vue?vue&type=script&lang=ts"
export * from "./SingerView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\SCMQ\\project\\HTML\\mq-player-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__